import { Box } from '@material-ui/core';
import { Comment } from '@nemuru-eng/js-api-client';
import React from 'react';

import { useCustomTheme } from '../../../../../../../../hooks/useCustomTheme';
import { useTranslation } from '../../../../../../../shared/hooks/useTranslation';
import { Font } from '../../../../../../../shared/components/Font';
import { useCalculateTime } from '../../../../../hooks/useCalculateTime';
import { getTransformedHtml } from '../../../../../utils/getTransformedHtml';
import { SupportAgentInfo } from './SupportAgentInfo';

interface ActivityLogCardProps {
  comments: Comment[];
  comment: Comment;
  index: number;
}

export const ActivityLogCard = ({ comments, comment, index }: ActivityLogCardProps) => {
  const { palette, customBorderRadius } = useCustomTheme();
  const { calculateTimePassed } = useCalculateTime();
  const { getTextIdTranslation } = useTranslation();

  const timePassed = calculateTimePassed({
    startDateStr: comments[index + 1]?.createdAt,
    endDateStr: comment.createdAt,
  });

  return (
    <>
      <Box
        display={'flex'}
        flexDirection={'column'}
        p={2}
        my={2}
        bgcolor={palette.grey[50]}
        borderRadius={customBorderRadius.paper}
      >
        <SupportAgentInfo comment={comment} />
        <Font variant={'body2'} color={'textSecondary'} style={{ paddingLeft: '56px', paddingTop: '8px' }}>
          {<span dangerouslySetInnerHTML={{ __html: getTransformedHtml(comment.htmlBody) }} />}
        </Font>
      </Box>
      {index !== comments.length - 1 && (
        <Box display={'flex'} flexDirection={'row'} justifyContent={'center'} alignItems={'center'} height={24}>
          <i className={'material-icons-outlined'} style={{ fontSize: 22, color: palette.grey[600], marginRight: 6 }}>
            schedule
          </i>
          <Font variant={'caption'}>{`${timePassed} ${getTextIdTranslation('LATER')}`}</Font>
        </Box>
      )}
    </>
  );
};
